import pino from 'pino'

import { isBrowser } from '@img-arena/consoles-utils'

/**
 * Creates a Pino logger instance with custom settings.
 *
 * The logger is configured to:
 * - Use the environment variable `PINO_LOG_LEVEL` for the default logging level, defaulting to 'info' if not set.
 * - Redact and remove any Bearer Tokens found in the log messages to enhance security. This is particularly
 *   important for logs that may include sensitive information, such as HTTP headers containing authorization data.
 *
 * Error Logging:
 * @param obj `error` param can be filled with an error object
 * @param msg `message` param is for custom messages outlining the log problem
 * @returns {pino.Logger} A Pino logger instance configured according to the specified options.
 */
let logger = pino({
  formatters: {
    level: (label) => {
      return { level: label.toUpperCase() }
    }
  },
  level: process.env.PINO_LOG_LEVEL || 'info',
  redact: { paths: ['err.config.headers.Authorization'], remove: true }
})

if (
  !isBrowser() &&
  process.env.NODE_ENV === 'development' &&
  process.env.NEXT_RUNTIME === 'nodejs'
) {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const pinoCaller = require('pino-caller')
  logger = pinoCaller(logger)
}

export default logger
